import { FC } from 'react';
// component
import IngredientsComponent from 'components/main/Ingredients';

const Ingredients: FC = () => {
  return <IngredientsComponent />;
};

export default Ingredients;
